<template>
    <spinner-until :condition="!showSpinner">
        <div class="patient-chart mt-page">

            <b-row class="mb-3 align-items-md-center">
                <b-col cols="12" md="3">
                    <h1 class="mb-md-0">
                        {{ $i18n.gt('HEADING_AT_A_GLANCE') }}
                    </h1>
                </b-col>
                <b-col cols="12" md="7" class="text-center">
                    <patient-id :participant="participant" class="mb-3 mb-md-0">
                    </patient-id>
                </b-col>
                <b-col cols="12" md="2" class="text-right">
                    <div class="next-page">
                        <router-link :to="`/participant/details/id/${participantId}`">
                            <shs-icon name="chevron-left"></shs-icon>
                            <span class="next-page__text">{{ $i18n.gt('LABEL_MANAGE_RECORDS') }}</span>
                        </router-link>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" md="7">
                    <b-card no-body>
                        <b-card-header>
                            <patient-chart-score-history-modal class="float-right"/>
                            <h2>{{ $i18n.gt('HEADING_RECENT_DATA') }}</h2>
                        </b-card-header>
                        <b-card-body>
                            <patient-current-data-summary :participant-id="participantId">
                            </patient-current-data-summary>
                        </b-card-body>
                    </b-card>

                    <b-card no-body>
                        <b-card-header>
                            <h2>{{ $i18n.gt('HEADING_COACHING') }}</h2>
                        </b-card-header>
                        <b-card-body>
                            <patient-coaching-summary :participant-id="participantId">
                            </patient-coaching-summary>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col cols="12" md="5" class="mb-3 mb-md-0">
                    <!-- create note buttons -->
                    <b-card no-body
                            v-if="authorizedNoteTypes.length > 0">
                        <b-card-header>
                            <h2 class="d-inline-block mr-5">{{ $i18n.gt('LABEL_ADD_NOTE') }}</h2>
                        </b-card-header>
                        <b-card-body>
                            <b-btn class="d-inline-block mr-3 mb-1"
                                   v-for="(type,i) in authorizedNoteTypes" :key="i"
                                   :to="`/participant/createNote/participantId/${participant.id}/type/${type}`">
                                {{ $i18n.gt(`LABEL_SURVEY_NOTE_TYPE_${type}`) }}
                                <shs-icon name="plus"></shs-icon>
                            </b-btn>
                        </b-card-body>
                    </b-card>

                    <!-- previous notes -->
                    <b-card no-body>
                        <b-card-header>
                            <h2>{{ $i18n.gt('HEADING_PREVIOUS_NOTES') }}</h2>
                        </b-card-header>
                        <b-card-body>
                            <survey-note-list :participantId="participantId"
                                              :for-patient="false">
                            </survey-note-list>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>

        </div>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import * as _ from 'lodash'
import SurveyNote from '@/providers/SurveyNote'
import PractitionerPatientMixin from "@/providers/PractitionerPatientMixin";

/**
 * Page for Practitioner to view Participant's basic info, Surveys, and previous SurveyNotes
 */
export default {
    name: 'PatientChart',
    mixins: [PractitionerPatientMixin],
    props: {
        participantId: Number
    },
    computed: {
        showSpinner() {
            // don't show until participant loaded, or if previous patient is still loaded
            return !this.participant || !this.participant.id || this.participant.id != this.participantId

        },
        authorizedNoteTypes() {
            return _.filter(SurveyNote.NON_RPM_NOTE_TYPES, (type) => {
                return this.$auth.canCreateDraftSoapNote(type)
            })
        },
        inProduction () {
            return this.$api.inProduction
        }
    },
    mounted() {
        // always reload participant data here - to cover cases such as
        // exiting a survey via the breadcrumbs
        this.loadParticipant(true) // see PractitionerPatientMixin
    },
    watch: {
        'provider.comment': {
            handler: function (newVal, oldVal) {
                if (newVal && oldVal) {
                    this.$api.updateComment(this, this.provider)
                        .then((response) => {
                            this.$toasted.show('Comment updated', {duration: 3000})
                        })
                }
            }
        }
    }
}
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
.patient-chart {
    h5 {
        text-transform: none !important;
    }
}

.patient-chart__dob {
    color: #999;
    font-size: .5em;
    padding-left: 50px;
}

.patient-chart__dob-date {
    color: #666;
    font-size: 1.5em;
    font-weight: bold;
}

.patient-chart__buttons {
    .btn {
        display: block;

        &:first-child {
            margin-bottom: 10px;
        }
    }
}

</style>
